import { useTaskFieldFlags } from './queries/useCabinetSettings';

/** Afficher un champ seulement si le flag chargé est true — pas de défaut tout-on. */
export function useEffectiveTaskFields() {
  const { data: flags } = useTaskFieldFlags();
  return {
    tags: flags?.tags === true,
    priority: flags?.priority === true,
    sections: flags?.sections === true,
  };
}
